// extracted by mini-css-extract-plugin
module.exports = {"dot":"styles_dot__1aFk_"};